<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path data-follow-fill="currentColor" d="M883.7 216.6c-91.4-91.2-239.4-91.2-330.8 0l-40.7 40.8-40.8-40.8c-43.8-44-103.3-68.7-165.4-68.5-62-.2-121.6 24.5-165.3 68.5C96.3 260.8 72 319.6 72 382s24.3 121.2 68.5 165.4l60.4 60.4 237.5 237.5c19.6 19.6 45.7 30.5 73.5 30.5 27.7 0 53.9-10.8 73.5-30.5l298.1-298.1c91.3-91.2 91.3-239.2.2-330.6zM180 507.9c-33.5-33.3-52.3-78.7-52.2-126 0-47.6 18.6-92.3 52.2-126 67.3-67.3 184.6-67.3 251.9 0l38.5 38.4-92.4 93.5c-45.4 45.6-45.3 119.3.3 164.7 21.8 21.7 51.2 33.9 82 34 29.9 0 59.7-11.4 82.4-34.1l92.3-93.2 129 129L546.2 806c-.7.7-1.6.9-2.3 1.5-18.5 16.2-48.3 15.9-65.8-1.5L180 507.9zm664.2.1-40.8 40.8-129.1-129.2-.4-.4-16-16-.1.1-25.4-25.2L501 510.8c-22.5 22.4-58.9 22.4-81.4 0-22.5-22.5-22.4-59 .1-81.5l102.7-103.7.2.2 69.6-69.6c69.6-69.5 182.3-69.5 252 0 69.4 69.5 69.4 182.2 0 251.8z" :fill="_fill" />
    </g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1.4em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}

@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
